export type ColumnPillVariant = 'required' | 'requiredBureau' | 'optionalIdentity'

export interface ColumnPill {
    name: string
    variant: ColumnPillVariant
}

export interface ColumnGroup {
    label: string
    /** Only where the label leaves something unsaid. */
    hint?: string
    /** Collapsed by default when set — keeps the card quieter. */
    collapsible?: boolean
    columns: ColumnPill[]
}

/** Spreadsheet columns grouped by how the batch runner uses them. */
export const COLUMN_GROUPS: ColumnGroup[] = [
    {
        label: 'Required for identity check',
        hint: 'Title is required for TransUnion; Equifax can still return without it.',
        columns: [
            { name: 'Title', variant: 'requiredBureau' },
            { name: 'First Name', variant: 'required' },
            { name: 'Last Name', variant: 'required' },
            { name: 'Date of Birth', variant: 'required' },
            { name: 'Postcode', variant: 'required' },
        ],
    },
    {
        label: 'Optional — address & contact',
        hint: 'Improves match quality at identity check.',
        collapsible: true,
        columns: [
            { name: 'Middle Name', variant: 'optionalIdentity' },
            { name: 'Phone', variant: 'optionalIdentity' },
            { name: 'Email', variant: 'optionalIdentity' },
            { name: 'Flat', variant: 'optionalIdentity' },
            { name: 'Building Number', variant: 'optionalIdentity' },
            { name: 'Building Name', variant: 'optionalIdentity' },
            { name: 'Street', variant: 'optionalIdentity' },
            { name: 'Town/City', variant: 'optionalIdentity' },
            { name: 'County', variant: 'optionalIdentity' },
        ],
    },
]

export const COLUMN_PILL_CLASS: Record<ColumnPillVariant, string> = {
    required: 'columnPillRequired',
    requiredBureau: 'columnPillRequiredBureau',
    optionalIdentity: 'columnPillOptionalIdentity',
}
